// extracted by mini-css-extract-plugin
export default {"multi-form-layout":"multi-form-layout-5284","form":"form-5b7c","cityImage":"cityImage-3f36"};